export default __webpack_public_path__ + "static/media/ep4-bg.17a61bb2.jpg";